import { z } from 'zod';

export const otelSchema = z
  .object({
    VITE_OTEL_SERVICE_NAME: z.string().optional().default('apresms-frontend'),
    VITE_OTEL_EXPORTER_OTLP_ENDPOINT: z.string().optional().default('/v1/traces'),
  })
  .transform((env) => ({
    otel: {
      serviceName: env.VITE_OTEL_SERVICE_NAME,
      tracesEndpoint: env.VITE_OTEL_EXPORTER_OTLP_ENDPOINT,
    },
  }));
